import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=02c3d6b7"
import script from "./Restaurant.vue?vue&type=script&lang=ts"
export * from "./Restaurant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports